import React from 'react';
import { Button } from './Button';
import { Check, Shield, Clock } from 'lucide-react';
export function Pricing() {
  return <section className="py-24 bg-white relative" data-id="element-68">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="bg-white rounded-[2.5rem] shadow-2xl border border-sage-light/30 overflow-hidden relative" data-id="element-70">
          {/* Top Banner */}
          <div className="bg-terracotta text-white text-center py-3 font-medium text-sm tracking-wide uppercase flex items-center justify-center" data-id="element-71">
            <Clock className="w-4 h-4 mr-2" data-id="element-72" />
            Oferta por tiempo limitado
          </div>

          <div className="p-8 md:p-12" data-id="element-73">
            <div className="text-center mb-10" data-id="element-74">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-75">
                El Método Maestro de Bio-Nutrición
              </h2>
              <p className="text-gray-600" data-id="element-76">
                Acceso inmediato de por vida + Todos los bonos
              </p>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-77">
              <div className="text-center md:text-right" data-id="element-78">
                <p className="text-gray-400 text-lg line-through decoration-red-500 decoration-2" data-id="element-79">
                  Valor Total: $197 USD
                </p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-80">Precio regular</p>
              </div>
              <div className="hidden md:block w-px h-16 bg-gray-200" data-id="element-81"></div>
              <div className="text-center md:text-left" data-id="element-82">
                <div className="flex items-start justify-center md:justify-start text-terracotta" data-id="element-83">
                  <span className="text-2xl font-bold mt-2" data-id="element-84">$</span>
                  <span className="text-6xl font-bold tracking-tighter" data-id="element-85">
                    37
                  </span>
                  <span className="text-xl font-bold mt-2 ml-1" data-id="element-86">USD</span>
                </div>
                <p className="text-sm font-bold text-sage-dark uppercase tracking-wider mt-1" data-id="element-87">
                  Pago Único
                </p>
              </div>
            </div>

            <div className="bg-cream-light rounded-2xl p-6 mb-10" data-id="element-88">
              <h4 className="font-bold text-gray-900 mb-4 text-center" data-id="element-89">
                Lo que obtienes hoy:
              </h4>
              <div className="grid md:grid-cols-2 gap-4" data-id="element-90">
                {["El Libro Digital 'Más Años Juntos'", 'Bono 1: Recetario Express', 'Bono 2: Guía de Suplementos', 'Bono 3: Masterclass Etiquetas', 'Bono 4: Planificador 14 Días', 'Bono 5: Diccionario Tóxico', 'Acceso de por vida', 'Actualizaciones gratuitas'].map((item, i) => <div key={i} className="flex items-center" data-id="element-91">
                    <div className="w-5 h-5 rounded-full bg-sage flex items-center justify-center mr-3 shrink-0" data-id="element-92">
                      <Check className="w-3 h-3 text-white" data-id="element-93" />
                    </div>
                    <span className="text-gray-700 text-sm" data-id="element-94">{item}</span>
                  </div>)}
              </div>
            </div>

            <div className="text-center" data-id="element-95">
              <Button size="lg" fullWidth className="md:w-auto md:min-w-[300px] text-lg shadow-xl shadow-terracotta/30" data-id="element-96">
                Sí, Quiero la Biblia Ahora
              </Button>
              <p className="mt-4 text-sm text-gray-500 flex items-center justify-center" data-id="element-97">
                <Shield className="w-4 h-4 mr-2 text-sage" data-id="element-98" />
                Garantía incondicional de 30 días. Pago 100% seguro.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}